import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Injector, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DataService } from '@app/shared/common/auth/data.service';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppConsts } from '@shared/commonHelper/AppConsts';
import { CommonLookupServiceProxy, LookUpTables, StripeServiceProxy } from '@shared/service-proxies/service-proxies';
import { AttachCustomerPaymentMethodRequest, CreateSubscriptionInputDto, LocalBillingDetailInput, ServiceProxy } from '@shared/service-proxies/stripe-service-proxy';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'vf-subscription-billing-detail-modal',
  templateUrl: './subscription-billing-detail-modal.component.html'
})
export class SubscriptionBillingDetailModalComponent extends AppComponentBase implements OnInit {
  @ViewChild('subscriptionBillingDetailModal') modal: ModalDirective;
  @ViewChild('editBillingDetailsForm') editBillingDetailsForm: NgForm;
  @ViewChild('cardInfo') cardInfo: ElementRef;
  //@Output() refreshBillingDetails: EventEmitter<void> = new EventEmitter<void>();
  @Output() errorProcessingStripeModalEmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() subscriptionSuccessEmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeEmit: EventEmitter<any> = new EventEmitter<any>();
  localBillingDetail: LocalBillingDetailInput = new LocalBillingDetailInput();
  card: any;
  cardHandler = this.onChange.bind(this);
  cardError: string;
  countryId: any;
  stateId: any;
  selectedCountryName = '';
  countrySearchText = '';
  countries: Array<any> = new Array<any>();
  states: Array<any> = new Array<any>();
  isShowCalled = false;
  isFromUpgradeModal = false;
  busyLoad = false;
  isSavingSubscription = false;
  cardInvalid = false;
  cardRequired = false;
  isFromBanner: boolean;
  clientSecret: string;
  // subscriptionId!: string | undefined;
  currency: string;
  planName: string;
  amount: number;
  quantity: number;
  unit: string;
  noOfUsers = 0;
  minUsers = 0;
  maxUsers = 4;
  priceId: string;
  subUnit: string;
  customerId: string;
  prodDetail: any;
  prodIdx = -1;
  planType = 0;
  couponDetails: any;
  showCouponInput = false;
  discountCode = '';
  discountCodeError = false;
  cardLast4 = '';
  constructor(injector: Injector,
    private _serviceProxy: ServiceProxy,
    private dataService: DataService,
    private _stripeServiceProxy: StripeServiceProxy,
    private _commonLookupServiceProxy: CommonLookupServiceProxy,
    private cd: ChangeDetectorRef) {
    super(injector);
  }

  ngOnInit() {
    let that = this;
    $(document).on('keydown', function (event) {
      if (event.key === 'Escape') {
        if (that.card) {
          that.card.removeEventListener('change', that.cardHandler);
          that.card.destroy();
        }
      }
    });
    this.getDropdownData();
    this.createCustomer();
  }
  private getDropdownData() {
    let filterinput_14: any = { filter: '', isEntityIdsNameRequired: false, entityIds: '', LookUpTables: LookUpTables._14, isInActiveDataRequired: false, excludeIds: null, sorting: '', skipCount: 0, maxResultCount: 999999 };
    this._commonLookupServiceProxy.getAllForLookupTable(
      filterinput_14.sorting,
      filterinput_14.skipCount,
      filterinput_14.maxResultCount,
      filterinput_14.filter,
      filterinput_14.isEntityIdsNameRequired,
      filterinput_14.entityIds,
      filterinput_14.LookUpTables,
      filterinput_14.isInActiveDataRequired,
      filterinput_14.excludeIds
    ).subscribe(result => {
      this.countries = result;
    });
  }

  private onChange({ error, empty }) {
    this.cardRequired = false;
    if (empty) {
      this.cardRequired = true;
      this.cardInvalid = false;
    } else if (error) {
      this.cardInvalid = true;
      this.cardRequired = false;
    } else {
      this.cardInvalid = false;
    }
    this.cd.detectChanges();
  }

  private initiateCardElement(): void {
    // Giving a base style here, but most of the style is in scss file
    const cardStyle = {
      base: {
        color: '#2E384D',
        fontFamily: '"Rubik", sans- serif',
        fontSmoothing: 'antialiased',
        fontSize: '14px',
        '::placeholder': {
          color: '#8798AD',
          opacity: '1'
        }
      },
      invalid: {
        fontFamily: '"Rubik", sans-serif',
        color: '#EC4343',
      }
    };
    this.card = elements.create('card', { cardStyle });
    this.card.mount(this.cardInfo.nativeElement);
    this.card.addEventListener('change', this.cardHandler);
  }

  private createCustomer() {
    this._serviceProxy.createCustomer().subscribe(result => {
      if (result.isError) {
        console.error('Failed to ensure Stripe customer:', result.errorMessage);
      }
    });
  }

  private createSubscription(): void {
    const input = new CreateSubscriptionInputDto();
    input.type = this.planType;
    input.quantity = this.noOfUsers;
    input.coupon = this.couponDetails ? this.couponDetails.id : undefined;
    input.couponId = this.couponDetails ? this.couponDetails.couponId : undefined;
    this.isSavingSubscription = true;
    this._serviceProxy.createSubscription(input).subscribe(result => {
      this.isSavingSubscription = false;
      if (!result.isError) {
        // this.localBillingDetail.subscriptionId = result.responseData.id;
        this.toastr.success('Successfully subscribed to a Plan.', null, AppConsts.toastrOption);
        this.subscriptionSuccess();
        this.resetValues();
      } else {
        this.showTransactionError();
      }
      this.busyLoad = false;
    });
  }
  private resetValues() {
    this.cardRequired = false;
    this.cardInvalid = false;
    this.selectedCountryName = '';
    this.countryId = undefined;
    if (this.card) {
      this.card.removeEventListener('change', this.cardHandler);
      this.card.destroy();
    }
    this.editBillingDetailsForm.resetForm();
    this.setFormPristine(this.editBillingDetailsForm);
  }

  show(item?: any): void {
    // New upgrade modal flow: {plan: 'annual'|'monthly', quantity: number, total: number}
    if (item && !Array.isArray(item) && item.plan !== undefined) {
      this.showFromUpgradeModal(item);
      return;
    }
    // Existing array-based flow (from trial ended / error modals)
    let isFromErrorModl = item[3];
    if (isFromErrorModl) {
      this.resetValues();
    }
    this.prodDetail = item;
    this.isShowCalled = true;
    this.busyLoad = true;
    this.isFromBanner = item[2];
    this.planType = item[1] === 0 ? 4 : 1;
    let usedSeats = this.appSession.tenant.usedSeats || 0;
    if (item[1] === 0) {
      let idx = item[0].findIndex(x => x.interval === 'year');
      this.prodIdx = idx;
      this.minUsers = Math.max(2, usedSeats);
      this.maxUsers = 999999;
    } else {
      let idx = item[0].findIndex(x => x.interval === 'month');
      this.prodIdx = idx;
      this.minUsers = Math.max(2, usedSeats);
      this.maxUsers = 999999;
    }
    this.planName = item[0][this.prodIdx].name;
    this.currency = item[0][this.prodIdx].currency;
    this.amount = item[0][this.prodIdx].price;
    this.priceId = item[0][this.prodIdx].priceId;
    this.unit = item[0][this.prodIdx].unit;
    this.noOfUsers = Math.max(item[0][this.prodIdx].noOfUsers > 1 ? item[0][this.prodIdx].noOfUsers : 1, this.minUsers);
    this.subUnit = item[1] === 0 ? 'year' : 'qtr';
    this.initiateCardElement();
    this.busyLoad = false;
    this.modal.show();
    setTimeout(() => {
      this.updateBodyForCenterModalShow();
    }, 600);

    setTimeout(() => {
      this.isShowCalled = false;
      this.setFormPristine(this.editBillingDetailsForm);
    }, 1000);
  }

  private showFromUpgradeModal(data: { plan: string, quantity: number, total: number }): void {
    this.isShowCalled = true;
    this.isFromUpgradeModal = true;
    this.busyLoad = true;
    this.isFromBanner = false;
    let usedSeats = this.appSession.tenant.usedSeats || 0;
    this.minUsers = Math.max(2, usedSeats);
    this.noOfUsers = Math.max(data.quantity || 2, this.minUsers);
    this.maxUsers = 999999;
    this.planType = data.plan === 'annual' ? 4 : 1;
    this.subUnit = data.plan === 'annual' ? 'year' : 'month';

    this.planName = 'Professional';
    this.amount = data.plan === 'annual' ? 190 : 19;
    this.currency = 'usd';
    this.busyLoad = false;

    this.initiateCardElement();
    this.modal.show();
    setTimeout(() => {
      this.updateBodyForCenterModalShow();
    }, 600);
    setTimeout(() => {
      this.isShowCalled = false;
      this.setFormPristine(this.editBillingDetailsForm);
    }, 1000);
  }

  get filteredCountries(): Array<any> {
    if (!this.countrySearchText) {
      return this.countries;
    }
    const search = this.countrySearchText.toLowerCase();
    return this.countries.filter(c => c.name.toLowerCase().includes(search));
  }

  onCountryDropdownToggle(): void {
    this.countrySearchText = '';
  }

  selectCountry(country: any): void {
    this.countryId = [country.id.toString()];
    this.selectedCountryName = country.name;
    this.onCountryChange(this.countryId);
  }

  onCountryChange(eventData): void {
    if (!this.isShowCalled) {
      const usData = this.countries.filter(t => t.id.toString() === eventData[0]);
      if (usData.length > 0) {
        this.localBillingDetail.state = undefined;
      }
    }
  }

  validateCoupon() {
    this.discountCode = this.discountCode.trim();
    if (this.discountCode !== '') {
      this._stripeServiceProxy.validateCoupon(this.discountCode).subscribe(result => {
        if (!result.isError) {
          this.couponDetails = result.responseData;
        } else {
          this.discountCodeError = true;
        }
      });
    } else {
      return;
    }

  }

  clearCoupon() {
    this.discountCode = '';
    this.discountCodeError = false;
    this.couponDetails = undefined;
  }

  onCodeInput(ev: any) {
    this.discountCodeError = false;
  }

  purchaseNow() {
    if (this.editBillingDetailsForm.valid && (!this.cardInvalid || !this.cardRequired)) {
      this.busyLoad = true;
      const usData = this.countries.filter(t => t.id.toString() === this.countryId[0]);
      if (usData.length > 0) {
        if (usData[0].abbreviation === 'US' && this.stateId) {
          const stateData = this.states.find(t => t.id.toString() === this.stateId[0]);
          if (stateData) {
            this.localBillingDetail.state = stateData.name;
          }
        }
        this.localBillingDetail.country = usData[0].abbreviation;
      }
      this.localBillingDetail.customerId = this.customerId;
      this.localBillingDetail.noOfUsers = this.noOfUsers;
      stripe
        .createPaymentMethod({
          type: 'card',
          card: this.card,
          billing_details: {
            name: this.localBillingDetail.name,
            address: {
              city: this.localBillingDetail.city,
              country: this.localBillingDetail.country,
              line1: this.localBillingDetail.addressLine1,
              line2: this.localBillingDetail.addressLine2,
              postal_code: this.localBillingDetail.postalCode,
              state: this.localBillingDetail.state
            }
          },
        }).then(result => {
          if (result && result.paymentMethod && result.paymentMethod.id) {
            this.localBillingDetail.paymentMethodId = result.paymentMethod.id;
            this.cardLast4 = result.paymentMethod.card ? result.paymentMethod.card.last4 : '';
            // Attach payment method to customer, then create subscription
            const pmInput = new AttachCustomerPaymentMethodRequest();
            pmInput.paymentMethodId = result.paymentMethod.id;
            pmInput.customerId = this.customerId;
            this._serviceProxy.createPaymentMethod(pmInput).subscribe(pmResult => {
              if (!pmResult.isError) {
                this.createSubscription();
              } else {
                this.showTransactionError();
                this.busyLoad = false;
              }
            });
          } else {
            this.showTransactionError();
            this.busyLoad = false;
          }
        });
    } else {
      this.setFormDirty(this.editBillingDetailsForm);
    }
  }

  close() {
    if (this.modal.isShown) {
      this.modal.hide();
      this.updateBodyForCenterModalHide();
      if (this.card) {
        this.card.removeEventListener('change', this.cardHandler);
        this.card.destroy();
      }
    }
  }

  closeBeforeActions() {
    let wasFromUpgrade = this.isFromUpgradeModal;
    if (this.modal.isShown) {
      this.modal.hide();
      this.updateBodyForCenterModalHide();
      if (this.card) {
        this.card.removeEventListener('change', this.cardHandler);
        this.card.destroy();
      }
    }
    this.isFromUpgradeModal = false;
    if (!wasFromUpgrade) {
      this.dataService.showBanner.next();
      this.dataService.showSubTrialEndModal.next();
    }
    this.closeEmit.emit({ fromUpgrade: wasFromUpgrade });
  }

  getDiscountAmount(): number {
    if (this.couponDetails && this.couponDetails.percent_off) {
      return (this.couponDetails.percent_off / 100) * (this.amount * this.noOfUsers);
    }
    return 0;
  }

  getTotal(): number {
    return (this.amount * this.noOfUsers) - this.getDiscountAmount();
  }

  showTransactionError() {
    this.close();
    this.errorProcessingStripeModalEmit.emit([this.localBillingDetail, this.card, this.priceId, this.isFromBanner, this.amount, this.prodDetail, this.cardLast4]);
    this.closeEmit.emit();
  }

  subscriptionSuccess(): void {
    this.close();
    this.subscriptionSuccessEmit.emit([this.planName, this.isFromBanner]);
    this.closeEmit.emit();
  }

}
